export const createCarrierUserReloadYardCarrierMini = /* GraphQL */ `
  mutation CreateCarrierUserReloadYardCarrier(
    $input: CreateCarrierUserReloadYardCarrierInput!
    $condition: ModelCarrierUserReloadYardCarrierConditionInput
  ) {
    createCarrierUserReloadYardCarrier(input: $input, condition: $condition) {
      id
      updatedAt
    }
  }
`;

export const updateCarrierUserMini = /* GraphQL */ `
  mutation UpdateCarrierUser(
    $input: UpdateCarrierUserInput!
    $condition: ModelCarrierUserConditionInput
  ) {
    updateCarrierUser(input: $input, condition: $condition) {
      id
      cognitoId
      updatedAt
    }
  }
`;

export const updateCarrierUserReloadYardCarrierMini = /* GraphQL */ `
  mutation UpdateCarrierUserReloadYardCarrier(
    $input: UpdateCarrierUserReloadYardCarrierInput!
    $condition: ModelCarrierUserReloadYardCarrierConditionInput
  ) {
    updateCarrierUserReloadYardCarrier(input: $input, condition: $condition) {
      id
      updatedAt
    }
  }
`;

// The generated create/update pair does not select `identifiers` until the next
// `amplify codegen` run, and the manager's Carriers form, the inline create
// dialog, the CSV import and the carrier portal's company profile all read the
// saved record back. Overridden here so a save returns the numbers it just
// wrote.
//
// The `users` connection stays selected even though no save path writes it: the
// react-admin store *replaces* the cached record with the mutation's response,
// so a field left out comes back empty rather than untouched. Dropping it would
// empty the Users tab on the manager's carrier form, and tell
// isCarrierProfileSelfManaged that a company-held profile is the yard's again.
export const createCarrierWithIdentifiers = /* GraphQL */ `
  mutation CreateCarrier(
    $input: CreateCarrierInput!
    $condition: ModelCarrierConditionInput
  ) {
    createCarrier(input: $input, condition: $condition) {
      id
      owner
      active
      groups
      businessName
      dbaName
      email
      phone
      normalizedEmail
      normalizedPhone
      identifiers {
        scheme
        value
      }
      reloadYardId
      users {
        items {
          id
          active
          blockAccess
          carrierUserId
          reloadYardId
          businessName
          firstName
          lastName
          type
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;

export const updateCarrierWithIdentifiers = /* GraphQL */ `
  mutation UpdateCarrier(
    $input: UpdateCarrierInput!
    $condition: ModelCarrierConditionInput
  ) {
    updateCarrier(input: $input, condition: $condition) {
      id
      owner
      active
      groups
      businessName
      dbaName
      email
      phone
      normalizedEmail
      normalizedPhone
      identifiers {
        scheme
        value
      }
      reloadYardId
      users {
        items {
          id
          active
          blockAccess
          carrierUserId
          reloadYardId
          businessName
          firstName
          lastName
          type
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;

// Saving the company profile, selecting exactly what the query above reads back.
//
// The field list has to match: react-admin *replaces* the cached record with a
// mutation's response, so anything selected by the query and left out here comes
// back empty rather than untouched — the form would lose the numbers it had just
// shown until the page was reloaded.
//
// `yards` is left out of both for the reason given on getCarrierCompany.
export const updateCarrierCompanyProfile = /* GraphQL */ `
  mutation UpdateCarrierCompany(
    $input: UpdateCarrierCompanyInput!
    $condition: ModelCarrierCompanyConditionInput
  ) {
    updateCarrierCompany(input: $input, condition: $condition) {
      id
      groups
      businessName
      email
      phone
      normalizedEmail
      normalizedPhone
      identifiers {
        scheme
        value
      }
      createdAt
      updatedAt
    }
  }
`;

// A write that changes nothing, used by the admin dashboard's company backfill to
// put a carrier entry through its own stream resolver.
//
// An empty update is the point. handleCarrierChange places any entry it sees with
// no companyId, so touching the row is enough to have the resolver do the work —
// with the claim table, the derived ids and the conflict rules it already has,
// rather than a second copy of them out here where the claim table cannot even be
// written (CarrierIdentifierClaim generates no mutations on purpose).
//
// `companyId` is selected so the caller can see whether the stamp has landed yet.
export const touchCarrier = /* GraphQL */ `
  mutation UpdateCarrier($input: UpdateCarrierInput!) {
    updateCarrier(input: $input) {
      id
      companyId
      updatedAt
    }
  }
`;

// The dbaName backfill's one write. Only the trading name goes in the input, so
// nothing else on the row — least of all the admin-only companyId — is sent back.
export const setCarrierDbaName = /* GraphQL */ `
  mutation UpdateCarrier($input: UpdateCarrierInput!) {
    updateCarrier(input: $input) {
      id
      dbaName
      updatedAt
    }
  }
`;
